<template>
  <div
    class="overlay-loader"
    :class="{
      _loading: active,
    }"
  >
    <!-- 3 dots for the loading animation -->
    <div class="dots">
      <span class="dot" />
      <span class="dot" />
      <span class="dot" />
    </div>
  </div>
</template>

<script setup lang="ts">
// Props
interface Props {
  active?: boolean;
}

const { active = true } = defineProps<Props>();
</script>

<style lang="scss">
@import "@styles/layout/z-map";
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";

.overlay-loader {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: $overlay-01;
  z-index: z-map("overlay-loader");
  display: none;

  &._loading {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .dots {
    display: flex;
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    ~ svg,
    ~ button {
      visibility: hidden;
    }
  }

  .dot {
    height: 0.5rem;
    width: 0.5rem;
    background-color: $interactive-01;
    border-radius: 100%;
    margin: $spacing-02;
    animation: loading 2s ease-in-out infinite;

    &:nth-child(2) {
      animation-delay: 0.4s;
    }

    &:nth-child(3) {
      animation-delay: 0.8s;
    }
  }

  @keyframes loading {
    50% {
      opacity: 0;
      transform: scale(0.7) translateY(10px);
    }
  }
}
</style>
